import React from 'react'
import './CatalogPageCartItem.scss'

import { ReactComponent as DeleteIcon } from '../../../components/assets/CatalogPage/TrashCatalogPageHead.svg'
import useFindInCart from '../../../../hooks/useFindInCart'
import useFindItemByUnit from '../../../../hooks/useFindItemByUnit'
import { useDispatch } from 'react-redux'

import {
  deleteCartElem,
  setCartElemQuantityDecrement,
  setCartElemQuantityIncrement,
  setCartElemQuantityValue,
} from '../../../../store/slices/allItemsCart'

const CatalogPageCartItem = ({ item }) => {
  const dispatch = useDispatch()
  const inCart = useFindInCart(item)

  const handleDelete = () => {
    dispatch(deleteCartElem({ sku: item.sku }))
  }

  const handleDecrement = () => {
    if (item.quantity > 1) {
      dispatch(setCartElemQuantityDecrement({ sku: item.sku }))
      return
    }
  }

  const handleIncrement = () => {
    dispatch(setCartElemQuantityIncrement({ sku: item.sku }))
  }

  const handleInputChange = (e) => {
    // Передаем значение, sku и сам элемент (как требует ваш редьюсер)
    dispatch(
      setCartElemQuantityValue({
        sku: item.sku,
        value: e.target.value,
        elem: item,
      })
    ) 
    console.log(typeof(e.target.value))
  }
  const handleInputBlur = (e) => {
    // Передаем значение, sku и сам элемент (как требует ваш редьюсер)
    if (item?.quantity == 0 || item?.quantity === undefined || item?.quantity === null || item?.quantity === '' || item?.quantity === ' ') {
      dispatch(
        setCartElemQuantityValue({
          sku: item.sku,
          value: 1,
          elem: item,
        })
      )
    }
  }

  // Расчет множителя цены (если у вас сложная логика единиц измерения)
  const unitMultiplier = useFindItemByUnit(
    item,
    inCart?.currentUnit || item?.unit?.split(',')[0]
  )

  return (
    <div className='CatalogPageCartItem'>
      <div className='imgBox'>
        <img src={item?.img} alt={item?.name} />
      </div>
      <div className='content'>
        <div className='Name'>{item?.name}</div>
        <div className='Articule'>{item?.skuProveedor}</div>
        <div className='rw'>
          <div className='Counter'>
            <DeleteIcon onClick={handleDelete}/>
            <button onClick={handleDecrement}>
              <svg width='8' height='1' viewBox='0 0 8 1' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path d='M0.5 0.5H7.5' stroke='#0A0A0A' strokeLinecap='round' strokeLinejoin='round' />
              </svg>
            </button>
            <input 
              value={inCart?.quantity || ''}
              onChange={handleInputChange}
              onBlur={handleInputBlur}
              type='number'
              min="0"
            />
            <button onClick={handleIncrement}>
              <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path d='M2.5 6H9.5' stroke='#0A0A0A' strokeLinecap='round' strokeLinejoin='round' />
                <path d='M6 2.5V9.5' stroke='#0A0A0A' strokeLinecap='round' strokeLinejoin='round' />
              </svg>
            </button>
          </div>
          <div className='Price'>
            <span className='Price__withoutVat'>
              €
              {(item?.initialPrice *
                useFindItemByUnit(item, inCart?.currentUnit || item?.unit?.split(',')[0]) * 1)?.toFixed(2)}
            </span>
            <p className='Price__withVat'>
              IVA/IGIC Incl. €
              {(
                (item?.spoPrice * (useFindItemByUnit(item, inCart?.currentUnit || item?.unit?.split(',')[0]) * 1)) /
                (1 + item.IVA / 100)
              )?.toFixed(2)}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CatalogPageCartItem
